module.exports = __webpack_public_path__ + "media/hit.f8648124.wav";